/**
 * Three columns use the tuned tokens in theme.css. Any other count gets its colours from a hue
 * sweep from the same red to the same green, so the axis still reads at a glance.
 */
export function columnColours(count: number, dark: boolean): string[] {
  const [h0, h1] = [8, 145];
  const sat = dark ? 68 : 62;
  const light = dark ? 62 : 43;
  return Array.from({ length: count }, (_, i) => {
    const t = count <= 1 ? 0 : i / (count - 1);
    return `hsl(${Math.round(h0 + (h1 - h0) * t)} ${sat}% ${light}%)`;
  });
}

function isDark(): boolean {
  const theme = document.documentElement.dataset['theme'];
  if (theme === 'dark') return true;
  if (theme === 'light') return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

/** Sets --m0..--m{n-1} on the root for a custom count; three columns fall back to the stylesheet. */
export function applyColumnColours(count: number): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement.style;
  for (let i = 0; i < 6; i++) root.removeProperty(`--m${i}`);
  if (count === 3) return;
  columnColours(count, isDark()).forEach((c, i) => root.setProperty(`--m${i}`, c));
}
